
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames   from 'classnames/bind';
import stylingUtils from '../../services/stylingUtilities';

import style from './style.scss';

class AccordionTitle extends React.Component {

    _getAccordionHeaderClassName() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'header': true,
            'header--open': this.props.expanded
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    _getArrowIcon() {

        if (this.props.expanded) {

            return <span styleName="arrow">&#9660;</span>;

        } else {

            return <span styleName="arrow-image"><img className={style['right-arrow']} src="/assets/images/right_arrow_white_48x48.png" /></span>;
        }
    }

    render() {

        return (
            <header onClick={ this.props.onClick } className={ this._getAccordionHeaderClassName() }>

                { this._getArrowIcon() }

                <h3 styleName="title">
                    { this.props.children }
                </h3>

            </header>
        );
    }
}

export default CSSModules(AccordionTitle, style);


// WEBPACK FOOTER //
// ./components/AccordionTitle/index.js